import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Spinner,
  Badge,
  UncontrolledTooltip,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import { FaCheck } from "react-icons/fa"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { map, range } from "lodash"
import { PiNotepad } from "react-icons/pi"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import MyPagination from "../../components/Common/MyPagination"

//actions

import "../../assets/scss/datatables.scss"

import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation"
import moment from "moment"
import { GiTeamIdea } from "react-icons/gi"
import { BiSolidPhoneCall } from "react-icons/bi"

import { deleteClient, getClients, getUsers } from "store/actions"
import { getAllFollowUp, updateFollowUp } from "store/followUp/actions"
import {
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min"
import FollowUpModal from "./Crud/Modal"
import { useCopyText } from "hooks/useCopyText"
import { useRole, ROLE_TYPES } from "hooks/useRole"
import useGetBranchDetails from "components/Common/Hooks/useGetBranchDetails"

const FollowUpDataTables = () => {
  const { isAnyRole } = useRole()
  const canViewAll = isAnyRole([
    ROLE_TYPES.SUPER_ADMIN,
    ROLE_TYPES.ADMIN,
    ROLE_TYPES.GENERAL_MANAGER,
  ])
  const dispatch = useDispatch()
  const history = useHistory()
  const { copyText } = useCopyText()

  const location = useLocation()
  const params = useParams()
  const [page, setPage] = useState(1)
  const [followUpModal, setFollowUpModal] = useState({
    status: false,
    data: {},
    value: "",
  })

  const [checkedMap, setCheckedMap] = useState({})

  const [totalListLimit, setTotalListLimit] = useState(30)

  const [Staff, setStaff] = useState("Select Staff...")
  const [StaffId, setStaffId] = useState("")
  const [StaffSearch, setStaffSearch] = useState("")

  const [filter, setFilter] = useState(canViewAll ? "inComplete" : "myTask")


  const [client, setClient] = useState("Select Client...")
  const [clientId, setClientId] = useState("")
  const [clientSearch, setClientSearch] = useState("")

  const [finalDateFormated, setFinalDateFormated] = useState({
    from: "",
    to: "",
  })
  const { loading, allFollowUp, allStaffs, allClients, allCounts } =
    useSelector(state => ({
      loading: state.FollowUp.loading,
      allFollowUp: state?.FollowUp?.followUps,
      allCounts: state?.FollowUp?.followUps?.statusCounts,
      allStaffs: state?.Members?.users?.users,
      allClients: state?.Client?.clients?.clients,
    }))

  const { branchId } = useGetBranchDetails()

  // Reset page to 1 when branch filter changes
  useEffect(() => {
    setPage(1)
  }, [branchId, finalDateFormated.from, finalDateFormated.to])

  useEffect(() => {
    if (params?.id) {
      dispatch(
        getAllFollowUp(
          page,
          filter,
          totalListLimit,
          StaffId,
          finalDateFormated,
          params?.id,
          clientId,
          branchId
        )
      )
    } else {
      dispatch(
        getAllFollowUp(
          page,
          filter,
          totalListLimit,
          StaffId,
          finalDateFormated,
          "",
          clientId,
          branchId
        )
      )
    }
  }, [
    dispatch,
    page,
    filter,
    totalListLimit,
    StaffId,
    finalDateFormated,
    params?.id,
    clientId,
    branchId
  ])

  const [isOpen, setIsOpen] = useState({ status: false, id: "" })

  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, status: false })
    dispatch(deleteClient(isOpen?.id))
  }

  const handleFollowUpStatus = status => {
    switch (status) {
      case "scheduled":
        return "SCHEDULED"
      case "pending":
        return "PENDING"
      case "done":
        return "DONE"
    }
  }

  const columns = [
    {
      dataField: "task",
      text: "Task",
      sort: true,
    },
    {
      dataField: "assignedDate",
      text: "Scheduled Date",
    },
    {
      ...filter === "done" && {
        dataField: "completedAt",
        text: "Completed Date",
      }
    },
    {
      dataField: "assignee.name",
      text: "Assignee Staff",
      sort: true,
    },
    {
      dataField: "client",
      text: "Client",
      sort: true,
    },

    {
      dataField: "createdAt",
      text: "Created",
      sort: true,
    },
    {
      dataField: "action",
      text: "Action",
    },
  ]

  const handleCopy = text => {
    copyText(text)
  }
  useEffect(() => {
    dispatch(getUsers("", "", StaffSearch, "", ''))
  }, [dispatch, StaffSearch])

  const staffOptions = [
    {
      label: "All",
      value: "",
    },
    {
      options: allStaffs?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result?._id,
      })),
    },
  ]

  const handleEntersStaffs = text => {
    setStaffSearch(text)
  }

  const handlerStaffsFinalValue = event => {
    setStaff(event?.label)
    setStaffId(event?.value)
    setPage(1)
  }
  const handleFollowUpStatusColor = color => {
    switch (color) {
      case "scheduled":
        return "info"
      case "pending":
        return "warning"
      case "done":
        return "success"

      default:
        return "info"
    }
  }

  const handleFollowUpType = type => {
    switch (type) {
      case "call":
        return <BiSolidPhoneCall className="fs-3" />
      case "meeting":
        return <GiTeamIdea className="fs-3" />
      case "task":
        return <PiNotepad className="fs-3" />
      case "other":
        return ""

      default:
        return ""
    }
  }

  const handleCheckbox = rowId => {
    setCheckedMap(prev => ({
      ...prev,
      [rowId]: true, // mark this row as done
    }))
    const updateStatus = {
      status: "done",
    }
    dispatch(updateFollowUp(updateStatus, rowId))
  }

  const handleColumns = () => {
    if (isAnyRole([ROLE_TYPES.SALES_MANAGER])) {
      return columns?.filter(i => i.dataField !== "action")
    } else return columns
  }

  const tableData = map(allFollowUp?.followUps, (item, index) => (
    {
      ...item,
      rawAssignedDate: item?.assignedDate,
      rawStatus: item?.status,
      id:
        item?.status !== "done" ? (
          <AvForm>
            <UncontrolledTooltip placement="bottom" target="checkbox">
              Mark as Done
            </UncontrolledTooltip>
            <AvField
              id="checkbox"
              name="checkbox"
              type="checkbox"
              // checked={checkbox}
              checked={!!checkedMap[item._id]}
              onChange={e => handleCheckbox(item?._id)}
              className="checkbox-custom"
            />
          </AvForm>
        ) : (
          <FaCheck style={{ color: "green" }} />
        ),

      message: (
        <div style={{ whiteSpace: "break-spaces" }}>
          {item?.message?.slice(0, 110)}
          {item?.message?.length > 110 ? " ..." : ""}
        </div>
      ),
      task: (
        <>
          <UncontrolledTooltip placement="bottom" target="checkbox">
            Mark as Done
          </UncontrolledTooltip>
          <div
            id="checkbox"
            style={{ whiteSpace: "break-spaces", minWidth: "120px" }} className="d-flex align-items-center">
            {item?.status !== "done" ? (
              <AvForm>

                <AvField
                  name="checkbox"
                  type="checkbox"
                  // checked={checkbox}
                  checked={!!checkedMap[item._id]}
                  onChange={e => handleCheckbox(item?._id)}
                  className="checkbox-custom"
                />
              </AvForm>
            ) : (
              <FaCheck style={{ color: "green" }} className="me-2" />
            )}

            <span
              onClick={() => item?.status !== "done" && handleCheckbox(item?._id)}
              style={{ cursor: item?.status !== "done" ? "pointer" : "default" }}
            >
              {item?.title
                ? `${item.title.slice(0, 70)}${item.title.length > 70 ? " ..." : ""}`
                : "----"}
            </span>
          </div>
        </>
      ),
      client: (
        <span style={{ color: "gray" }}>
          {console.log(filter)}
          {filter === "investment" ? item?.investmentLead?.name : item?.lead?.client?.name || "---"} <br />
          {filter === "investment" ? item?.investmentLead?.phone : item?.lead?.client?.phone || "---"}
        </span>
      ),
      mail: <span style={{ color: "gray" }}>{filter === "investment" ? item?.investmentLead?.email : item?.lead?.client?.email}</span>,
      status: item?.status && (
        <Badge
          style={{ textTransform: "capitalize" }}
          className={
            "px-2 py-2 badge-soft-" + `${handleFollowUpStatusColor(item?.status)}`
          }
        >
          {" "}
          {handleFollowUpStatus(item?.status)}{" "}
        </Badge>
      ),
      type: item?.type && (
        <div
          onClick={() => handleCopy(item?.assignee?.phone)}
          style={{ cursor: "pointer" }}
          title="copy"
        >
          {handleFollowUpType(item?.type)}
        </div>
      ),
      assignedDate: (() => {
        const assignedMoment = moment(item?.assignedDate)
        const today = moment().startOf("day")
        const isToday = assignedMoment.isSame(today, "day")
        const isTomorrow = assignedMoment.isSame(today.clone().add(1, "day"), "day")
        const isYesterday = assignedMoment.isSame(today.clone().subtract(1, "day"), "day")
        const isPast = assignedMoment.isBefore(today, "day")

        let labelText = ""
        let labelStyle = {}

        if (isToday) {
          labelText = "Today"
          labelStyle = {
            fontSize: "12px", color: "#28a745",
            padding: "2px 8px", borderRadius: "4px"
          }
        } else if (isTomorrow) {
          labelText = "Tomorrow"
          labelStyle = {
            fontSize: "12px", color: "#856404",
            padding: "2px 8px", borderRadius: "4px"
          }
        } else if (isYesterday && item?.status !== "done") {
          labelText = "Yesterday"
          labelStyle = {
            fontSize: "12px", color: "#721c24",
            padding: "2px 8px", borderRadius: "4px"
          }
        }

        return (
          <div>
            <div>{assignedMoment.format("DD/MM/YYYY")}</div>
            {labelText && (
              <div style={labelStyle}>{labelText}</div>
            )}
          </div>
        )
      })(),
      completedAt: item?.completedAt && (
        <span>{moment(item?.completedAt).format("DD/MM/YYYY")}</span>
      ),

      createdAt: (
        <span style={{ color: "gray" }}>
          {item?.createdBy?.name || "---"} <br />
          {moment(item?.createdAt).format("DD/MM/YYYY")}
        </span>
      ),


      action: (
        <div>
          <Button
            title="edit"
            id={`view${index}`}
            type="button"
            color="white"
            className="ms-1 btn"
            onClick={() =>
              setFollowUpModal({
                status: true,
                value: item?.type,
                data: item,
              })
            }
          >
            <i
              className="bx bx-edit me-2"
              style={{ color: "green", fontSize: "22px" }}
            />
          </Button>
        </div>
      ),
    }))

  const handlePageLimit = count => {
    setTotalListLimit(count)
  }


  const taskValues = [
    ...(canViewAll
      ? [{ label: "Pending", value: "inComplete", count: allCounts?.inComplete || 0 }]
      : []),
    { label: "My task", value: "myTask", count: allCounts?.myTask || 0 },
    {
      label: "Assigned Task",
      value: "assignedTask",
      count: allCounts?.assignedTask || 0,
    },
    ...(canViewAll
      ? [{ label: "Completed Tasks", value: "done", count: allCounts?.done }]
      : []),
    ...(isAnyRole([
      ROLE_TYPES.SUPER_ADMIN,
      ROLE_TYPES.BUSINESS_DEVELOPMENT_OFFICER,
    ])
      ? [{ label: "Investment Tasks", value: "investment", count: allCounts?.investment || 0 }]
      : []),
  ]
  const handleStatusController = value => {
    switch (true) {
      case isAnyRole([ROLE_TYPES.ADMIN]):
        return value
      case isAnyRole([ROLE_TYPES.GENERAL_MANAGER]):
        return value
      case isAnyRole([ROLE_TYPES.MANAGING_DIRECTOR]):
        return value
      case isAnyRole([ROLE_TYPES.BRANCH_MANAGER]):
        return ""
    }
  }

  const listTaskChangeFollowup = tabValue => {
    setFilter(tabValue)
    setPage(1)
    if (location?.pathname === "/dashboard") {
      return ""
    } else {
      history?.push({
        pathname: location.pathname,
        search: `p=${page}&t=${tabValue}`,
        state: {
          page: page,
          task: handleStatusController(tabValue),
          sort: "due",
        },
      })
    }
  }


  useEffect(() => {
    dispatch(getClients("", "", clientSearch, "", ""))
  }, [dispatch, clientSearch])

  const clientOptions = [
    {
      label: "All",
      value: "",
    },
    {
      options: allClients?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result?._id,
      })),
    },
  ]

  const handleEntersClients = text => {
    setClientSearch(text)
  }

  const handlerClientFinalValue = event => {
    setClient(event?.label)
    setClientId(event?.value)
    setPage(1)
  }

  const rowClasses = row => {
    if (row?.rawStatus === "done") {
      return ""
    }

    const today = moment().startOf("day")
    const assignedDate = moment(row?.rawAssignedDate).startOf("day")

    const isToday = assignedDate.isSame(today, "day")
    const isPast = assignedDate.isBefore(today, "day") // All past dates (yesterday and before)

    if (isToday) {
      return "today-row" // Light green for today
    } else if (isPast) {
      return "yesterday-row" // Light red for all due/overdue tasks
    }

    // Tomorrow and future dates get normal/white background
    return ""
  }


  // Pagination
  const totalPages = Math.ceil(allFollowUp?.total / totalListLimit)
  const pages = range(1, totalPages + 1)


  return (
    <React.Fragment>
      <Row className="mb-0">
        <DeleteModal
          show={isOpen?.status}
          onCloseClick={() => setIsOpen({ ...isOpen, status: false })}
          onDeleteClick={handleDeleteEvent}
        />
        {followUpModal?.status && <FollowUpModal
          onCloseClick={() => setFollowUpModal({ status: false, data: {} })}
          show={followUpModal?.status}
          updateData={followUpModal?.data}
          type={followUpModal?.value}
        />}
        <Col className="col-12">
          <Card style={{ minHeight: "fit-content" }} className="mb-0">
            <CardBody className="pt-2 ">
              <ToolkitProvider
                keyField="_id"
                key={"id"}
                columns={handleColumns()}
                data={tableData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    {params?.id && (
                      <div className="d-flex align-items-center justify-content-between pt-0 pb-2 w-100">
                        {/* <p className="m-0 p-0">Follow Ups</p> */}
                        <div>
                          {location?.pathname !== "/followUp/all/d" &&
                            (location?.pathname !== "/dashboard" ? (
                              <>
                                <Button
                                  type="button"
                                  color="info"
                                  className="btn btn-sm me-2 text-align-center "
                                  onClick={() =>
                                    setFollowUpModal({
                                      status: true,
                                      value: "call",
                                    })
                                  }
                                >
                                  + FollowUp Task
                                </Button>
                              </>
                            ) : null)}
                        </div>
                      </div>
                    )}
                    {!params?.id && (
                      <>
                        <div className="d-flex align-items-center justify-content-between mt-1">
                          <div
                            className="d-flex align-items-center justify-content-between"
                            style={{ width: "fit-content" }}
                          >
                            <div className="mb-0 mt-0">
                              {map(taskValues, (head, key) => (
                                <>
                                  <input
                                    type="radio"
                                    className="btn-check"
                                    name={`btn-radio${key + 1}`}
                                    id={head?.value}
                                    autoComplete="off"
                                    checked={filter === head?.value}
                                    onChange={() =>
                                      listTaskChangeFollowup(head?.value, key)
                                    }
                                  />
                                  <label
                                    className="btn btn-warning "
                                    htmlFor={head?.value}
                                    style={{
                                      borderRadius: 1,
                                      whiteSpace: "nowrap",
                                      backgroundColor: filter === head.value ? "#2784ff" : "transparent",
                                      borderColor: filter === head.value ? "#2784ff" : "#deebff",
                                      color: filter === head.value ? "#fff" : "#333",
                                      borderWidth: "1px",
                                      borderStyle: "solid",
                                      borderRadius: "5px",
                                      margin: "2px"
                                    }}
                                  >
                                    {head?.label}
                                    <Badge
                                      className={`font-size-12 ms-2 ${filter === head.value
                                        ? "badge-soft-light"
                                        : "badge-soft-primary"
                                        }`}
                                      pill
                                    >
                                      {head?.count}
                                    </Badge>
                                  </label>
                                </>
                              ))}
                            </div>



                          </div>
                          <div
                            className="d-flex align-items-center justify-content-end "
                            style={{ width: "fit-content" }}
                          >

                            <div>
                              {location?.pathname !== "/followUp/all/d" &&
                                (location?.pathname !== "/dashboard" ? (
                                  <>
                                    <Button
                                      type="button"
                                      color="warning"
                                      className="btn me-2 text-align-center "
                                      onClick={() =>
                                        setFollowUpModal({
                                          status: true,
                                          value: "call",
                                        })
                                      }
                                    // key={key}
                                    >
                                      + FollowUp Tasks
                                    </Button>
                                  </>
                                ) : null)}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex  align-items-center">
                          <div className="mt-2">
                            <label></label>

                            <AvForm className="form-horizontal mx-2 mb-3 d-flex align-items-center w-75">
                              <div className="mx-1">
                                <span className="">
                                  Show
                                  <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                                </span>
                              </div>
                              <div className="" style={{ width: "50px" }}>
                                <AvField
                                  name="pageLimit"
                                  className="form-control"
                                  value={totalListLimit}
                                  onChange={e =>
                                    handlePageLimit(e.target.value)
                                  }
                                  type="text"
                                  required
                                />
                              </div>
                            </AvForm>
                          </div>
                          {canViewAll && (
                            <>
                              <div
                                className="w-20 text-align-center me-1 "
                                style={{ width: "21%" }}
                              >
                                <label>Staff</label>
                                <Select
                                  onInputChange={handleEntersStaffs}
                                  value={Staff}
                                  placeholder={Staff}
                                  onChange={handlerStaffsFinalValue}
                                  options={staffOptions}
                                  classNamePrefix="select2-selection"
                                  isLoading={loading}
                                />
                              </div>

                              <div
                                className="w-21 text-align-center"
                                style={{ width: "21%" }}
                              >
                                <label>Client</label>
                                <Select
                                  onInputChange={handleEntersClients}
                                  value={client}
                                  placeholder={client}
                                  onChange={handlerClientFinalValue}
                                  options={clientOptions}
                                  classNamePrefix="select2-selection"
                                  isLoading={loading}
                                />
                              </div>

                              <div className="mx-1">
                                <AvForm style={{ marginTop: 8 }}>
                                  <span className="mt-1">Sort By Date</span>
                                  <div className={`d-flex date_wrapper `}>
                                    <div className="d-flex align-items-start position-relative">
                                      <AvField
                                        name="fromDate"
                                        type="date"
                                        validate={{
                                          dateRange: {
                                            start: { value: -5, units: "years" },
                                            end: { value: 5, units: "years" },
                                          },
                                        }}
                                        onChange={e =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            from: e.target.value,
                                          })
                                        }
                                        value={finalDateFormated?.from}
                                      />
                                      <button
                                        onClick={() =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            from: "",
                                          })
                                        }
                                        type="button"
                                        className="btn btn-white editable-cancel date_close btn-sm"
                                      >
                                        <i className="mdi mdi-close text-danger "></i>
                                      </button>
                                    </div>
                                    <div className="d-flex align-items-start position-relative">
                                      <AvField
                                        name="toDate"
                                        className="mx-1"
                                        type="date"
                                        validate={{
                                          dateRange: {
                                            start: { value: -5, units: "years" },
                                            end: { value: 5, units: "years" },
                                          },
                                        }}
                                        onChange={e =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            to: e.target.value,
                                          })
                                        }
                                        value={finalDateFormated?.to}
                                      />
                                      <button
                                        onClick={() =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            to: "",
                                          })
                                        }
                                        type="button"
                                        className="btn btn-white editable-cancel date_close btn-sm"
                                      >
                                        <i className="mdi mdi-close text-danger "></i>
                                      </button>
                                    </div>
                                  </div>
                                </AvForm>
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    )}

                    {loading && (
                      <Spinner color="secondary" className="d-block m-auto" />
                    )}
                    <>
                      {allFollowUp?.followUps?.length >= 1 ? (
                        <>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField={"_id"}
                                  key={"id"}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  hover={false}
                                  rowClasses={rowClasses}
                                  classes={"table align-middle table-nowrap table-sm"}
                                  headerWrapperClasses={"thead-light"}
                                  {...toolkitProps.baseProps}
                                />
                              </div>
                            </Col>
                          </Row>
                          <div className="d-flex align-items-center justify-content-between px-4">
                            <div className="w-75">
                              <MyPagination
                                totalPages={pages}
                                page={page}
                                setPage={setPage}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <p className="my-4 mx-3 ">No Follow Ups!</p>
                      )}
                    </>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default FollowUpDataTables
